import { useState, useEffect } from 'react';
import { StyledBar, StyledProgress } from './ProgressBar.styles';

interface Props {
  progress: number;
  total: number;
}

const ProgressBar = ({ progress, total }: Props) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    setWidth(Math.round((progress / total) * 100));
  }, [progress, total]);

  return (
    <StyledBar data-testid="progressbar-bar">
      {progress > 0 && total > 0 && <StyledProgress data-testid="progressbar-progress" $width={width} />}
    </StyledBar>
  );
};

export default ProgressBar;
